import {Rect} from './Rect';
import {Post} from './Post';
import {IObject3D} from '../../Interfaces';
import { EmptyRect } from './EmptyRect';

declare const THREE: any;

export class IntermediatePost extends Post {

  static readonly Name = 'IntermediatePost';

  private  image = new THREE.ImageLoader().load('assets/images/scene-plan/in.png');

  readonly edge: Feeney.IEdge;

  private static rotationTransform = new THREE.Matrix4().makeRotationX(THREE.Math.degToRad(-90));

  constructor(edge: Feeney.IEdge, image) {
    super();
    this.edge = edge;
    if (image) {
      this.image = image;
    }
    const picture = this.image;
    this.add(new EmptyRect(10));

    const geometry = new THREE.PlaneBufferGeometry(1, 1).applyMatrix(IntermediatePost.rotationTransform);
    const material = new THREE.MeshBasicMaterial({ side: THREE.DoubleSide, transparent: true });

    let mesh = new THREE.Mesh(geometry, material);
    mesh.name = "text";

    let canvas = document.createElement('canvas');

    let ctx = canvas.getContext('2d');

    mesh.scale.set(10 / picture.height * picture.width, 1, 8);
    canvas.width = 10 / picture.height * picture.width * 10;
    canvas.height = 8 * 10;


    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    // let fontSize = 100;
    // const text = this.type;
    // let font = "LatoWebLight";
    // ctx.font = "extra-condensed bolder " + fontSize + "px " + font;
    // ctx.textAlign = 'center';
    // ctx.fillText(text, canvas.width / 2, canvas.height);
    // ctx.strokeRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(this.image, 0, -canvas.height / 10, canvas.width, canvas.height * 1.2);

    if (!mesh.material.map) {
      mesh.material.map = new THREE.Texture(canvas);
    }
    mesh.material.map.image = canvas;

    mesh.material.map.needsUpdate = true;
    mesh.material.needsUpdate = true;

    mesh.name = "text";

    this.add(mesh);
    this.name = IntermediatePost.Name;
  }

  getRoot(): IObject3D {
    return this.parent;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Post/IntermediatePost.ts